<div class="modal-header">
  <div class="container-fluid">
    <!-- <app-logo-block></app-logo-block> -->
    <h2>Global Water Monitor</h2>
  </div>
</div>

<div class="row">
  <div class="col-xs-12 col-md-5">
    <p><strong>Free and up-to date information on climate and water anywhere in the world, measured by satellites and on the ground</strong></p>
    <!-- <p>The Global Water Monitor is an online web app that visualises and provides access to up-to-date information about our global climate and water resources.</p>
    <p>Information on rainfall, air temperature and humidity, soil moisture, river flows and the volume of water bodies are derived from a combination of station and satellite observations.</p>
    <p>The Global Water Monitor Consortium is a partnership of several individuals and organisations who share a mission to make global water information more current and available for public interest and debate.</p> -->
    <p>The Global Water Monitor is developed by a consortium of organisations and individuals that share the goal of providing free, rapid and global information on climate and water resources.
      Find out <a href="https://www.globalwater.online/">more here</a>.
    </p>
  </div>


  <div class="hidden-xs hidden-sm col-md-7">
    <a class="thumbnail">
      <img class="img-fluid rounded" src="assets/images/vicfalls.jpg">
    </a>
  </div>
</div>


<p class="small about-disclaimer">
  <strong>Disclaimer:</strong>&nbsp;The material provided on this website is experimental and derived through active research.
  The Australian National University does not have a legislated role in providing authoritative information.
  All information is made available on the understanding that it does not constitute professional advice.
  Before relying on the material in any important matter, users should carefully evaluate its accuracy, currency, completeness and relevance for their purposes, and should obtain any appropriate professional advice relevant to their particular circumstances. Links to other websites do not constitute an endorsement of material at those sites,
  or any associated organisation, product or service.
</p>

<div *ngIf="tours?.length" class="card text-dark bg-light">
  <div class="card-body">
    <p>The following tours allow you to see key events from 2024.</p>
    <tour-selection [list]="true" [tours]="tours" (tourStarted)="_tourStarted($event)"></tour-selection>
    <p>You can also access the tours from the <i class="fa fa-video-camera"></i> icon in the top right corner of the map.</p>
  </div>
</div>